/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveReferralRequestBody
 */
export interface RemoveReferralRequestBody {
    /**
     * 
     * @type {string}
     * @memberof RemoveReferralRequestBody
     */
    referralId: string;
}

/**
 * Check if a given object implements the RemoveReferralRequestBody interface.
 */
export function instanceOfRemoveReferralRequestBody(value: object): value is RemoveReferralRequestBody {
    if (!('referralId' in value) || value['referralId'] === undefined) return false;
    return true;
}

export function RemoveReferralRequestBodyFromJSON(json: any): RemoveReferralRequestBody {
    return RemoveReferralRequestBodyFromJSONTyped(json, false);
}

export function RemoveReferralRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveReferralRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'referralId': json['referralId'],
    };
}

export function RemoveReferralRequestBodyToJSON(json: any): RemoveReferralRequestBody {
    return RemoveReferralRequestBodyToJSONTyped(json, false);
}

export function RemoveReferralRequestBodyToJSONTyped(value?: RemoveReferralRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referralId': value['referralId'],
    };
}

